import React, { useContext, useEffect, useState } from 'react'
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import CustomToolbar from '../../components/grid/CustomToolbar'
import SL_Button from '../../components/buttons/Button'
import CreateMonitor from './CreateMonitor'
import DetailMonitor from './DetailMonitor'
import { Button, Popconfirm } from 'antd'
import { UserAddOutlined, FileSearchOutlined } from '@ant-design/icons'
import PateintFilters from './MonitorFilters'
import monitor_grid_columns from './grid_columns/monitor_grid_columns'
import { displayMessage } from '../../services/helper';

export default function ListMonitor() {
    const {
        setShowLoading,
        windowWidth, windowHeight, mobile_mode
    } = useContext(GeneralContext)

    const [monitor, setMonitor] = useState([])
    const [currentMonitor, setCurrentMonitor] = useState(null)
    const [isModalCreateMonitorVisible, setIsModalCreateMonitorVisible] = useState(false)
    const [isModalDetailMonitorVisible, setIsModalDetailMonitorVisible] = useState(false)

    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.7

    useEffect(() => {loadMonitorsData()},[])

    const loadMonitorsData = async (currentFilters) => {
        try {
            
            setShowLoading(true)

            const payload = { monitor_id: currentFilters?.monitor_id || null, ...currentFilters }
            const rs = await api.monitor.list(payload)
            gridRef.current.setSelectionModel([])
            setMonitor(rs.data)
            
        } finally {
            setShowLoading(false)
        }
    }

    const handleRowChange = (e) => {
        setCurrentMonitor(e?.row)
    }

    const handleOnCloseModalCreateMonitor = () => {
        setIsModalCreateMonitorVisible(false)
    }

    const handleOnOpenModalCreateMonitor = () => {
        setIsModalCreateMonitorVisible(true)
    }

    const handleOnCloseModalDetailMonitor = () => {
        setIsModalDetailMonitorVisible(false)
    }

    const handleOnOpenModalDetailMonitor = () => {
        setIsModalDetailMonitorVisible(true)
    }

    const renderCustomToolBar = () => {
        return (
            <CustomToolbar/>
        )
    }


    const handleOnClickResetPassword = monitor => {
        setShowLoading(true)
        api.auth.forceResetPassword(monitor).then(
            rs => {
                setShowLoading(false)
                alert(displayMessage('NEW_EMAIL_SENT_PASSWORD',[monitor?.email]), 'success')
            }
        )
    }

    const actionResetPassword = {
        field: 'action',
        headerName: displayMessage('RESET_PASSWORD'),
        width: 200,
        sortable: false,
        align: 'center',
        renderCell: (params) => {
            return (
                <div style={{ padding: 2 }}>
                    <Popconfirm zIndex={10001} placement="topLeft" title={displayMessage('COMFIRMATION_CHANGE_PASWORD')} onConfirm={() => 
                                handleOnClickResetPassword(params?.row)} okText={displayMessage('YES')} cancelText={displayMessage('NO')
                            }>
                        <Button type="primary"> {displayMessage('RESET_PASSWORD')} </Button>
                    </Popconfirm>
                </div>

            )
        },
        disableColumnSelector: true
    }

    return (
        <>
            {
                isModalCreateMonitorVisible
                &&
                <CreateMonitor
                    isModalVisible={isModalCreateMonitorVisible}
                    handleOnCloseModal={handleOnCloseModalCreateMonitor}
                    refreshMonitors={loadMonitorsData}
                />
            }


            {
                isModalDetailMonitorVisible
                &&
                <DetailMonitor
                    isModalVisible={isModalDetailMonitorVisible}
                    handleOnCloseModal={handleOnCloseModalDetailMonitor}
                    monitor_id={currentMonitor.id}
                    refreshMonitors={loadMonitorsData}
                />
            }

            <PateintFilters handleOnSearchMonitors={loadMonitorsData}/>
            <div className='flex flex-col w-full'>

                <div style={{ height: DataGridProHeight, minHeight: 300  }} >

                    <div className={`flex flex-1 justify-between p-2 bg-appian-blue gap-1 ${mobile_mode ? `flex-col` : `flex-row`} `}>
                        <span className='self-center text-white flex-1 text-center font-medium'>{displayMessage('MONITOR_LIST')}</span>
                        <div className={`flex gap-1 ${mobile_mode ? `flex-col` : `flex-row`}`} >
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                disabled={!currentMonitor}
                                style={{ color: !currentMonitor ? 'grey' : null, background: !currentMonitor ? 'lightgrey' : null }}
                                onClick={handleOnOpenModalDetailMonitor}
                                icon={<FileSearchOutlined />}
                            >
                                {displayMessage('DETAIL_MONITOR')}
                            </SL_Button>
                            <SL_Button
                                type='default'
                                className='items-center w-30 flex'
                                onClick={handleOnOpenModalCreateMonitor}
                                icon={<UserAddOutlined />}
                            >
                                {displayMessage('CREATE_MONITOR')}
                            </SL_Button>
                        </div>
                        
                    </div>
                    
                    
                    <DataGridPro
                        // rows={monitor ?? []}
                        rows={monitor}
                        apiRef={gridRef}
                        style={{ height: '100%' }}
                        columns={monitor_grid_columns.concat([
                            actionResetPassword
                        ])}
                        pagination
                        pageSize={100}
                        components={{
                            Toolbar: renderCustomToolBar,
                        }}
                        onRowClick={handleRowChange}
                        density="compact"
                        disableMultipleSelection
                    />
                </div>
            </div>
        </>
    )
}
